import { Fragment, memo, useMemo } from 'react';
import { Marker } from '@adamscybot/react-leaflet-component-marker';
import { MapFilterType, RouteMarkerType } from '@lp/features/RoutePlanner/types';
import { MARKER_TYPE_ICONS } from '@lp/features/RoutePlanner/config';
import { MapPointIcon } from '@icons';
import { getIconMapColor } from '@lp/features/RoutePlanner/utils';
import { SegmentTypeEnum } from '@/api/apis/route';

export const ResourceRouteMarker = memo(
  ({ location, type }: RouteMarkerType & { type: MapFilterType | MapFilterType[] }) => {
    const color = getIconMapColor(SegmentTypeEnum.custom);

    const icon = useMemo(() => {
      const hidePin = type.length > 1 && type.includes(MapFilterType.ocsDevices);

      return (
        <div>
          {!hidePin && (
            <div className="relative flex flex-col justify-center items-center mt-3">
              <div className="relative text-base-25 mt-0.5 overflow-hidden" style={{ color }}>
                <MapPointIcon />
                <span className="w-full font-secondary text-center absolute top-[6px] left-[6px] text-base-90 text-s-sb">
                  <div className="box-border w-3 h-3 rounded-full bg-white" style={{ borderColor: color }} />
                </span>
              </div>
              <div className="box-border w-3 h-3 rounded-full border-3 bg-white" style={{ borderColor: color }} />
            </div>
          )}
          <div
            className={`relative flex rounded-full justify-center items-center p-1.5 shadow-xl bg-white gap-1 ${hidePin && 'top-[22px]'}`}
          >
            {Array.isArray(type)
              ? // eslint-disable-next-line react/no-array-index-key
                type.map((t, i) => <Fragment key={`${t}-${i}-${location.toString()}`}>{MARKER_TYPE_ICONS[t]}</Fragment>)
              : MARKER_TYPE_ICONS[type]}
          </div>
        </div>
      );
    }, [type, color, location]);

    return (
      <Marker
        position={location}
        zIndexOffset={10}
        componentIconOpts={{
          disableClickPropagation: true,
        }}
        icon={icon}
      />
    );
  },
);
